import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import CheckCircleDefault from 'src/app/icons/Monospaced/CheckCircle/CheckCircleDefault';
import CheckCircleFilled from 'src/app/icons/Monospaced/CheckCircle/CheckCircleFilled';
import CheckCircleLine from 'src/app/icons/Monospaced/CheckCircle/CheckCircleLine';

export interface CheckItemTextProps {
  text: string;
  size: 'sm' | 'md' | 'lg';
  type: 'default' | 'line' | 'filled';
  color: 'primary' | 'gray' | 'success';
}

const ICON_MAP = {
  default: CheckCircleDefault,
  line: CheckCircleLine,
  filled: CheckCircleFilled,
};

const SIZE_MAP = {
  sm: 24,
  md: 28,
  lg: 32,
};

type ColorMap = {
  [key in keyof typeof ICON_MAP]: {
    [key: string]: {
      color: string;
      colorSecondary?: string;
    };
  };
};

const COLOR_MAP: ColorMap = {
  default: {
    primary: {
      color: 'var(--bg-brand-primary)',
      colorSecondary: 'var(--fg-featured-icon-brand)',
    },
    gray: {
      color: 'var(--gray-light-100)',
      colorSecondary: 'var(--gray-light-500)',
    },
    success: {
      color: 'var(--success-100)',
      colorSecondary: 'var(--success-600)',
    },
  },
  line: {
    primary: {
      color: 'var(--brand-600)',
    },
    gray: {
      color: 'var(--gray-light-400)',
    },
    success: {
      color: 'var(--success-600)',
    },
  },
  filled: {
    primary: {
      color: 'var(--brand-600)',
    },
    gray: {
      color: 'var(--gray-light-400)',
    },
    success: {
      color: 'var(--success-600)',
    },
  },
};

const CheckItemText = ({ text, size, type, color }: CheckItemTextProps): JSX.Element => {
  const Icon = ICON_MAP[type];

  const { color: iconColor, colorSecondary: iconColorSecondary } = COLOR_MAP[type][color];
  const iconSize = SIZE_MAP[size];

  return (
    <Stack
      direction='row'
      align='flex-start'
      justify='flex-start'
      gap='spacing-lg'
    >
      <Stack>
        <Icon
          width={iconSize}
          color={iconColor}
          colorSecondary={iconColorSecondary}
        />
      </Stack>
      <Typography
        text={text}
        type='paragraph'
        size={size}
        color='text-tertiary'
        textAlign='left'
      />
    </Stack>
  );
};

export default CheckItemText;
